/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const financialsCoreMetricDtoSchema = z.object({
  title: z.optional(z.string()),
  value: z.string().nullish(),
  sub: z.string().nullish(),
  group: z.optional(z.string()),
});
